
import {
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
} from 'vue';

export default defineComponent({
  emits: [
    'outside',
    'inside',
  ],

  setup(props, context) {
    const root = ref<InstanceType<typeof HTMLElement>>();

    const checkIfClickedOutside = (event: Event) => {
      if (!root.value) return;

      const withinBoundaries = event.composedPath().includes(root.value);

      if (!withinBoundaries) {
        context.emit('outside');
      } else {
        context.emit('inside');
      }
    };

    onMounted(() => {
      window.addEventListener('click', checkIfClickedOutside);
    });

    onBeforeUnmount(() => {
      window.addEventListener('click', checkIfClickedOutside);
    });

    return {
      root,
    };
  },
});
